







import {defineComponent, onMounted, PropType} from "@vue/composition-api"
import ActivitiesComponent from './components/Activities/ActivitiesComponent.vue'
import AttendedActivitiesComponent from './components/AttendedActivities/AttendedActivitiesComponent.vue'
import {useActions, useGetters} from "vuex-composition-helpers"
import Loader from "@/shared/components/Loader.vue"
import {Config} from "./models/config-viewmodel";

export default defineComponent({
    name: "MyStudyChoiceActivities",
    components: {
        ActivitiesComponent,
        AttendedActivitiesComponent,
        Loader
    },
    props: {
        widgetComponent: {
            type: String,
            required: true,
            default: 'ActivitiesComponent',
            validator: (value: string) => {
                return ['ActivitiesComponent', 'AttendedActivitiesComponent'].includes(value);
            }
        },
        config: {
            type: Object as PropType<Config>,
            required: true
        }
    },
    setup: (props) => {
        const {setConfig, loadInitialData} = useActions(['setConfig', 'loadInitialData']);
        setConfig(props.config)
        const {loading, getConfig} = useGetters(['loading', 'getConfig']);
        const loadText = getConfig.value?.language === 'nl' ? 'Even geduld... Uw studiekeuze activiteiten worden geladen' : 'One moment please... Your studychoice activities are loaded';

        onMounted(async () => {
            await loadInitialData();
        })
        
        return {
            loading,
            loadText
        }
    }
})
